import React, { useState } from "react";
import "./Car.css";

const cars = [
  {
    name: "CAMRY",
    image: "images/camry.png",
    details: {
      ac: "AC",
      seats: 4,
      pricing: [
        { route: "Jeddah to Makkah", price: 300 },
        { route: "Madina to Ziarah", price: 200 },
        { route: "Jeddah to Madina", price: 500 },
        { route: "Makkah to Jeddah", price: 250 },
        { route: "Makkah to Madina", price: 450 },
        { route: "Madina to Jaddah", price: 450 },
        { route: "Madina Hotel to Madina Airport", price: 150 },
        { route: "Makkah to Jaddah Visit", price: 600 },
        { route: "Makkah to Taif Visit", price: 500 },
        { route: "Makkah to Ziarah", price: 250 },
      ],
      hourlyRate: 80,
      note: "------The Family who takes the round trip gets 50 SR Discount-------",
    },
  },
  {
    name: "HIACE",
    image: "images/hiace.png",
    details: {
      ac: "AC",
      seats: 11,
      pricing: [
        { route: "Jeddah to Madina", price: 700 },
        { route: "Jaddah to Makkah", price: 400 },
        { route: "Makkah to Madina", price: 650 },
        { route: "Madina to Jeddah", price: 650 },
        { route: "Makkah to Jaddah Visit", price: 850 },
        { route: "Makkah to Taif Visit", price: 650 },
        { route: "Madina Hotel to Madina Airport", price: 300 },
        { route: "Madina to Baddar Visit", price: 600 },
        { route: "Madina to Ziarat", price: 300 },
        { route: "Makkah to Ziarat", price: 350 },
      ],
      hourlyRate: 150,
      note: "------The Family who takes the round trip gets 100 SR Discount-------",
    },
  },
  {
    name: "Coaster",
    image: "images/coaster.png",
    details: {
      ac: "AC",
      seats: 17,
      pricing: [
        { route: "Jeddah to Madina", price: 1000 },
        { route: "Jaddah to Makkah", price: 500 },
        { route: "Makkah to Madina", price: 900 },
        { route: "Madina to Jeddah", price: 900 },
        { route: "Makkah to Jaddah Visit", price: 1100 },
        { route: "Makkah to Taif Visit", price: 900 },
        { route: "Madina Hotel to Madina Airport", price: 450 },
        { route: "Madina to Baddar Visit", price: 850 },
        { route: "Madina to Ziarat", price: 400 },
        { route: "Makkah to Ziarat", price: 450 },
      ],
      hourlyRate: 200,
      note: "Exclusive Offer: Family discounts available.",
    },
  },
  {
    name: "GMC",
    image: "images/gmc.png",
    details: {
      ac: "AC",
      seats: 7,
      pricing: [
        { route: "Jeddah to Madina", price: 1000 },
        { route: "Jaddah to Makkah", price: 450 },
        { route: "Makkah to Madina", price: 900 },
        { route: "Madina to Jeddah", price: 900 },
        { route: "Makkah to Jaddah Visit", price: 1200 },
        { route: "Makkah to Taif Visit", price: 900 },
        { route: "Madina Hotel to Madina Airport", price: 350 },
        { route: "Madina to Baddar Visit", price: 1000 },
        { route: "Madina to Ziarat", price: 350 },
        { route: "Makkah to Ziarat", price: 400 },
      ],
      hourlyRate: 200,
      note: "------The Family who takes the round trip gets 100 SR Discount-------",
    },
  },
  {
    name: "H1",
    image: "images/h1.png",
    details: {
      ac: "AC",
      seats: 7,
      pricing: [
        { route: "Jeddah to Madina", price: 600 },
        { route: "Jaddah to Makkah", price: 350 },
        { route: "Makkah to Madina", price: 550 },
        { route: "Madina to Jeddah", price: 550 },
        { route: "Makkah to Jaddah Visit", price: 700 },
        { route: "Makkah to Taif Visit", price: 600 },
        { route: "Madina Hotel to Madina Airport", price: 250 },
        { route: "Madina to Baddar Visit", price: 550 },
        { route: "Madina to Ziarat", price: 250 },
        { route: "Makkah to Ziarat", price: 300 },
      ],
      hourlyRate: 100,
      note: "------The Family who takes the round trip gets 75 SR Discount-------",
    },
  },
{
  name: "STARIA",
  image: "images/staria.png",
  details: {
    ac: "AC",
    seats: 9,
    pricing: [
      { route: "Jeddah to Makkah", price: 300 },
      { route: "Jeddah to Madina", price: 550 },
      { route: "Makkah to Madina", price: 500 },
      { route: "Madina to Jeddah", price: 500 },
      { route: "Makkah Ziarat", price: 250 },
      { route: "Madina Ziarat", price: 200 },
      { route: "Makkah to Jeddah (Visit)", price: 650 },
      { route: "Makkah to Taif (Visit)", price: 550 },
      { route: "Madina to Badr (Visit)", price: 500 },
      { route: "Madina Airport to Hotel", price: 200 }
    ],
    hourlyRate: 110,
    note: "Travel in style with the STARIA for ultimate comfort."
  },
 },  
];

const CarDetails = () => {
  const [selectedCar, setSelectedCar] = useState(cars[0]); // Default to first car

  const handleCarSelect = (car) => {
    setSelectedCar(car);
  };

  return (
    <div className="car-section">
      {/* Navbar-like Section for Car Selection */}
      <div className="car-navbar">
        {cars.map((car, index) => (
          <button
            key={index}
            className={`car-item ${
              selectedCar.name === car.name ? "active" : ""
            }`}
            onClick={() => handleCarSelect(car)}
          >
            {car.name}
          </button>
        ))}
      </div>

      {/* Car Details Box */}
      <div className="car-details">
        <div className="car-info">
          <p className="note">
            <strong>Note:</strong> {selectedCar.details.note}
          </p>
          <h2>{selectedCar.name} Car Service</h2>
          <p>
            <strong>AC: </strong>
            {selectedCar.details.ac}
          </p>
          <p>
            <strong>Seats: </strong>
            {selectedCar.details.seats}
          </p>
          <h3>Pricing:</h3>
          <ul>
            {selectedCar.details.pricing.map((item, index) => (
              <li key={index}>
                {item.route}: {item.price} SR
              </li>
            ))}
          </ul>
          <p>
            <strong>Per Hour Rate: </strong>
            {selectedCar.details.hourlyRate} SR
          </p>
        </div>
        <img
          src={selectedCar.image}
          alt={selectedCar.name}
          className="car-image"
        />
      </div>
    </div>
  );
};

export default CarDetails;
